<template>
	<div class="wrapper">
		<headerTag />
		<div style="margin-top: 4.68rem;">
			
			<van-list
			   :immediate-check="false"
			  v-model="loading"
			  :finished="finished"
			  finished-text="没有更多了"
			   @load="onLoad"
			>
				<router-link :to="{ name:'zxDetail', params: {id: item.nId} }" v-for="item in list">
					<div class="zxDiv"> 
						<img :src="item.mListImg" alt="" />
						<div>
							<p>{{item.nTitle}}</p>
							<p>
								<span>{{item.publicTime}}</span>
								<span>
									<img src="../../assets/images/user/view.png" alt=""/>
									<i>{{item.nCount}}</i>
								</span>
							</p>
						</div>
					</div>
				</router-link>
			</van-list>
			
		</div>
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
	import { List } from 'vant'
	
    
    export default {
    	name: 'zixunPage',
    	props: {
        
    	},
		data(){
		  return {
		    list: [],
		    loading: false,
		    finished: false,
			page:1,
			limit:10,
			total:'',
		  }
		},
    	components: {
    		headerTag,
			[List.name]:List ,
    	},
		 methods: {
			 loadNewsInfo(){
			 	this.axios({
			 	    method: 'POST',
			 	    url:'/news/getNewsInfo',
			 		params:{
			 			page:this.page,
			 			limit:this.limit,
			 		},
			 	}).then((res)=>{
			 			if(res.data.code==1000){
			 				let data = res.data.data;
							if(data.list != null && data.list.length > 0){
								for(var i=0,len=data.list.length;i < len;i++){
									let _data=data.list[i];
									_data.mListImg=this.rootUrl+_data.mListImg;
								}
							}
							this.list=this.list.concat(data.list); 
							this.total=data.total;
							
			 			}
			 	}).catch((err)=>{
			 		 this.$message.error({message: '获取数据失败'});
			 	})
			 },
			onLoad() {
			       // 异步更新数据
			       setTimeout(() => {
					 this.page++;
					 this.loadNewsInfo();
					 
			         // 加载状态结束
			         this.loading = false;
			 
			         // 数据全部加载完成
					  if (this.list.length >= this.total) {
					        this.finished = true;
					    }
			       }, 500);
			   },
		 },
		created(){
			 this.loadNewsInfo();
		  } 
    }
</script>